import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-drop-up",
  "use": "arrow-drop-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-drop-up\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7 14 5-5 5 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol